/**
 * Mutations for search
 */
export const mutations = {
  // SIMPLE SETTERS
  setSearchValue(state, value) {
    state.searchValue = value;
  },
  setStartDate(state, value) {
    state.startDate = value;
  },
  setEndDate(state, value) {
    state.endDate = value;
  },
  setFiltertypeAll(state, value) {
    state.filtertypeAll = value;
  },
  setFiltertypeSubject(state, value) {
    state.filtertypeSubject = value;
  },
  setFiltertypeSender(state, value) {
    state.filtertypeSender = value;
  },
  setFiltertypeReceiver(state, value) {
    state.filtertypeReceiver = value;
  },

  // COMPLEX SETTERS
  /**
   * Prevent search result to being removed
   * @param {Object} state
   */
  preventRemoveResults(state) {
    state.removeResults = false;
  },

  /**
   * Searching loader start
   * @param {Object} state
   */
  startSearching(state) {
    state.searchingLoader = true;
  },

  /**
   * Stop loader start
   * @param {Object} state
   */
  stopSearching(state) {
    state.searchingLoader = false;
  },

  /**
   * Clear search result
   * @param {Object} state
   */
  clearResults(state) {
    state.results = {};
  },

  /**
   * Set the search result
   * @param {Object} state
   * @param {String} results
   */
  setResultsForSearch(state, results) {
    // Step 1: Check if any results are returned
    if (!results) {
      state.results = false;
      return;
    }

    // Step 2: Loop through all the results and create result
    const endRes = {};
    results.forEach(res => {
      if (res.app_type === 0) {
        if (`person.${res.client_id}` in endRes) {
          endRes[`person.${res.client_id}`].push(res);
        } else {
          endRes[`person.${res.client_id}`] = [res];
        }
      } else if (res.app_type === 1 && res.otherevent_id !== 0) {
        let first = "";
        if (res.otherevent_type === 0) {
          first = "event_appointment";
        } else if (res.otherevent_type === 1) {
          first = "other_event";
        } else if (res.otherevent_type === 2) {
          first = "group_appointment";
        }
        if (`${first}.${res.otherevent_id}` in endRes) {
          endRes[`${first}.${res.otherevent_id}`].push(res);
        } else {
          endRes[`${first}.${res.otherevent_id}`] = [res];
        }
      } else {
        if ("other" in endRes) {
          endRes.other.push(res);
        } else {
          endRes.other = [res];
        }
      }
    });

    // Step 3: Update state
    state.results = endRes;
  },
  /**
   * Set the search result
   * @param {Object} state
   * @param {String} results
   */
  setEmailResultsForSearch(state, results) {
    // Step 1: Check if any results are returned

    // Step 3: Update state
    state.emailResults = results;
  },

  /**
   * Bringing state to default
   * @param {Object} state
   */
  emptySearchAll(state) {
    // Step 1: Check if prevention is required
    if (!state.removeResults) {
      state.removeResults = true;
      state.showResultsNow = true;
      return;
    }
    // Step 2: Clear if not required
    state.searchValue = "";
    state.results = {};
    state.emailResults = {};
    state.searchingLoader = false;
    state.showResultsNow = false;
    state.filtertypeAll = true;
    state.filtertypeSubject = false;
    state.filtertypeSender = false;
    state.filtertypeReceiver = false;
  }
};
